import BaseEntity from './base/BaseEntity.model';
import Direccion from './direccion.model';
import Telefono from './telefono.model';
import Documento from './documento.model';

export default class Oficina extends BaseEntity{

    public codigo?: string;
    public estacionesTrabajo?: number;
    public disenoAccesible?: string;
    public posicion?: string;
    public institucionId?: number;
    public institucionNombre? : string;
    public responsableId?: number;
    public direccionId?: number;
    public direccion?: Direccion;
    public telefonos: Telefono[] = [];
    public fotos: Documento[] = [];

    constructor(){
        super();
    }

    
}